<template>
  <el-row :gutter="40" class="panel-group">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" >
        <div class="card-panel-icon-wrapper icon-sim">
          <svg-icon icon-class="sim" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            卡片总数
          </div>
          <count-to :start-val="0" :end-val="chartData.totalCard" :duration="100" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-card-delete">
          <svg-icon icon-class="card-delete" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            销卡总数
          </div>
          <count-to :start-val="0" :end-val="chartData.totalDelCard" :duration="100"  class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-card-active">
          <svg-icon icon-class="card-active" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            激活总数
          </div>
          <count-to :start-val="0" :end-val="chartData.totalActiveCard" :duration="100"   class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-off">
          <svg-icon icon-class="off" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            停机总数
          </div>
          <count-to :start-val="0" :end-val="chartData.totalStopCard" :duration="100"  class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  components: {
    CountTo
  },
  data() {
    return {
      chartData: {}
    }
  },
  props: {
    panelData: {
      type: Object,
      required: true
    }
  },
  watch: {
    panelData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
      immediate: true
    }
  },
  methods: {
    setOptions(data){
        this.chartData = data;
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-card-active{
        background: #36a3f7;
      }

      .icon-card-delete {
        background: #f4516c;
      }

      .icon-sim {
        background: #34bfa3;
      }
      .icon-off {
        background: #f124c7;
      }
    }


    .icon-card-active {
      color: #36a3f7;
    }

    .icon-card-delete {
      color: #f4516c;
    }

    .icon-sim {
      color: #34bfa3
    }
    .icon-off {
      color: #f124c7;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
